import TabButton from "../../components/atoms/buttons/TabButton";
import { workInProgressAlert } from "../../utils/HelperFunctions";

function BrandSettingsTab() {
  return (
    <div className="max-w-[56rem] font-sora">
      <span className="my-3 mb-2 text-3xl font-semibold text-white lg:text-5xl">Account Settings</span>
      <div className="my-3 flex space-x-7 text-sm font-semibold ">
        <TabButton label="PROFILE" isActive />
        <TabButton label="TEAM" handleOnClick={workInProgressAlert} />
        <TabButton label="BILLING" handleOnClick={workInProgressAlert} />
      </div>
    </div>
  );
}

export default BrandSettingsTab;
